<template>
    <div>
        <div class="actions" v-if="type !== 'edit'">
            <b-button variant="success" @click="openModal(true, 'add', customer )"> {{$t('general.add')}}</b-button>
        </div>
        <b-table-simple hover responsive>
            <b-thead>
                <b-th> {{$t('customer.subs.subscription')}}</b-th>
                <b-th> {{$t('customer.subs.beginDate')}} </b-th>
                <b-th> {{$t('customer.subs.endDate')}} </b-th>
                <b-th> {{$t('general.operation')}} </b-th>
            </b-thead>
            <b-tbody>
                <b-tr v-for="subs in subscribtionList" :key="subs.id">
                    <b-td> {{subs.sub.name}} </b-td>
                    <b-td> {{moment(subs.begin_date)}} </b-td>
                    <b-td> 
                        <b-badge :variant="expiredIn(subs.end_date) < 0 ? 'danger':'info'" v-b-popover.hover="popoverConfig(subs.end_date)">
                            <span v-if="expiredIn(subs.end_date) < 0">{{$t('general.expired')}}</span>
                            <span v-else>{{expiredIn(subs.end_date)}} {{$t('general.expiredIn')}}</span>
                        </b-badge>    
                    </b-td>
                    <b-td> 
                        <b-icon 
                            v-if="subs.sub.name === 'Alarm Merkezi'" 
                            icon="shield-fill-plus"
                            variant="success" 
                            scale="1.5" 
                            shift-v="1.5"
                            aria-hidden="true" 
                            :title="$t('general.add')" 
                            @click="$router.push({ path: '/Accounts/Add/'+customer.data })" 
                        />
                        <b-icon 
                            icon="pencil-square" 
                            variant="primary"
                            scale="1.5" 
                            shift-v="1.5" 
                            aria-hidden="true"
                            :title="$t('general.edit')" 
                            @click="openModal(true, 'edit', subs)" 
                        />
                        <b-icon
                            icon="trash"
                            variant="danger"
                            scale="1.5"
                            shift-v="1.5"
                            aria-hidden="true"
                            :title="$t('general.delete')"
                            @click="openModal(true, 'delete', {id: subs.id})" 
                        />
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
        <Modals v-if="modalOpen" :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />

    </div>

</template>
               
<script>
    import Modals from "../modals/"
    import moment from 'moment'
    import i18n from '@/plugins/i18n'

    export default {
        name: "Subscribtion",
 
        computed: {
            subscribtionList(){
                return this.$store.getters.getCustomerSubscriptions
            }
            
        },
        data: function(){
            return{
                modalOpen: false,
                modalProps: {},
                currentForm:"CustomerSubscription",
                modalName: ""
            }
        },
        methods:{
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
            moment: function(data){
                return moment(data).format('DD MMMM YYYY');
            },
            expiredIn(val) {
                const today = moment()
                const expDate = moment(val.split('T')[0])
                return expDate.diff(today, 'days') + 1
            },
            popoverConfig(data) {
                return {
                    html: true,
                    placement: 'bottom',
                    customClass: 'popover',
                    content: () => {
                        const date = this.moment(data)
                        const content = `<strong>${i18n.t('general.endDate')}: </strong>${date}`
                        return content
                    },
                }
            },
        },
        props:{
            customer: Object,
            type: String
        },
        components:{
            Modals
        }
    }
</script>

<style lang="css" scoped > 
    @import "../styles/subscriptions.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Customer/components/Subscribtion.vue